import { del, get, patch, post, put } from '../client';

export const equipmentApi = {
  list: (params) => get('/equipment', { params }),
  getById: (id) => get(`/equipment/${id}`),
  create: (body) => post('/equipment', body),
  update: (id, body) => put(`/equipment/${id}`, body),
  updateKyc: (id, body) => patch(`/equipment/${id}/kyc`, body),
  remove: (id) => del(`/equipment/${id}`),
  indentHistory: (id) => get(`/equipment/${id}/indent-history`),
};
